import React from "react";
import "./SectionHeader.scss";
import {withRouter} from 'react-router-dom'
import {Fade} from 'react-reveal'
import {connect} from "react-redux";
import {AddFilter} from "../../Actions";
import ReactTooltip from "react-tooltip";
import {assetUrl} from "../../serviceApi";

const AngleRight = assetUrl+"images/Icon_Forward.svg";
const dot_icon = assetUrl+"images/info-icon.svg";


function SectionHeader(props) {
	const {image, heading, viewmore, redirect, party_filter, topGainerFilter, topLoserFilter, tooltip} = props;

	const viewMoreHandler = () => {
		if (party_filter || topGainerFilter || topLoserFilter) {
			if (party_filter) {
				let filter_obj = {
					party: {id: party_filter.id, partyName: party_filter.partyName}
				};
				props.applyFilter(filter_obj)
			} else if (topGainerFilter) {
				let filter_obj = {
					short_by: "high_to_low"
				}
				props.applyFilter(filter_obj)
			} else if (topLoserFilter) {
				let filter_obj = {
					short_by: "low_to_high"
				}
				props.applyFilter(filter_obj)
			}

			props.history.push(redirect)
		} else {
			props.history.push(redirect)
		}

	}

	return (
		<>
			{/*<Fade bottom delay={500}>*/}
				<div className={"section-header-component d-flex align-items-center justify-content-between"}>
					<div className={"d-flex align-items-center justify-content-between"}>
						<img src={image} alt={'alt'} className={"img-fluid"} style={{width: "24px", height: "24px"}}/>
						<p className={"section-title"}>{heading}</p>
						{tooltip === "upcoming" &&
						<div style={{position: "relative"}}>
							<img alt={"alt"} src={dot_icon} className="dot_icon" style={{marginLeft: "6px",marginBottom:"2px"}}
							     data-for={'upcoming'} data-tip/>

							{/*<div>*/}
								<ReactTooltip id='upcoming' type='light' effect={"solid"}
								              place={"right"}>
									<span className={"tooltip-light"}>You can subscribe to shares of new politicians at face<br/> value before they become tradable in the market.</span>
								</ReactTooltip>
							{/*</div>*/}
						</div>
						}

					</div>
					{
						viewmore ?
							<div className={"d-flex align-items-center"} style={{zIndex:10}} onClick={() => viewMoreHandler()}>
								<p className={"view-all-text"}>View All</p>
								<img src={AngleRight} alt={"AngleRight"}/>
							</div>
							: null
					}
				</div>
			{/*</Fade>*/}
		</>
	);
}

const mapDispatchToProps = dispatch => ({
	applyFilter: data => dispatch(AddFilter(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(SectionHeader));